import AnimatedLoadingModal from './AnimatedLoadingModal';

export default AnimatedLoadingModal;
